import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop: React.FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll window to top
    window.scrollTo(0, 0);
    
    // Also scroll any scrollable content containers to top
    const contentWrapper = document.querySelector('.dashboard-content-wrapper');
    if (contentWrapper) {
      contentWrapper.scrollTop = 0;
    }
    
    const dashboardContent = document.querySelector('.dashboard-content');
    if (dashboardContent) {
      dashboardContent.scrollTop = 0;
    }
  }, [pathname]);

  return null;
};

export default ScrollToTop;

